import React, { useCallback } from 'react';

// INTERFACES
import { ISearchInputProps } from '../../interfaces/SearchInput.interface';

// STYLES
import { SearchInputContainer, Input } from './styles';

const SearchInput: React.FC<ISearchInputProps> = ({
  id,
  name,
  icon,
  type,
  placeholder,
  onSearch
}: ISearchInputProps) => {
  const handleChange = useCallback(
    (e: any) => {
      onSearch(e.target.value);
    },
    [onSearch]
  );

  return (
    <SearchInputContainer>
      {icon}
      <Input id={id} name={name} type={type} placeholder={placeholder} onChange={handleChange} />
    </SearchInputContainer>
  );
};

export default SearchInput;
